<template>
    <v-expansion-panels class="expansion-docs">
        <v-expansion-panel v-for="(section, index) in sections">
          <v-expansion-panel-header expand-icon="mdi-plus">
            <h4 class="expansion-docs__title">{{ section.name }}</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ol class="expansion-docs__list">
              <li class="expansion-docs__item"
                  v-for="(link, index) in section.links"
                  :key="index"
              >
                <a :href=link.href target="_blank" class="expansion-docs__link">
                  <img src="/upload/pdf.svg" alt="pdf">
                  <div class="expansion-docs__info">
                    <span>{{ link.name }}</span>
                    <div class="expansion-docs__info--details">
                      <span>{{ link.date }}</span>
                      <span>{{ link.size }}</span>
                    </div>
                  </div>

                  <div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 15.2044L4 18.8925C4 19.4514 4.21071 19.9875 4.58579 20.3827C4.96086 20.778 5.46957 21 6 21H18C18.5304 21 19.0391 20.778 19.4142 20.3827C19.7893 19.9875 20 19.4514 20 18.8925V15.2044M12.0011 3V14.9425M12.0011 14.9425L16.5725 10.3793M12.0011 14.9425L7.42969 10.3793"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </div>
                </a>
              </li>
            </ol>
          </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: "expansionDocs",
    props: {
        docs: Array | String | Number | Boolean | Object,
        items: Array | String | Number | Boolean | Object,
    },
    data() {
        return {
            links: this.docs,
          sections: this.items,
            /*links: [
                {
                    href: '/1',
                    name: 'Файл 1',
                    date: '08.09.2022',
                    size: 'PDF 0.25 МБайт',
                },
                {
                    href: '/2',
                    name: 'Файл 2',
                    date: '08.09.2022',
                    size: 'PDF 0.25 МБайт',
                },
                {
                    href: '/2',
                    name: 'Файл 3',
                    date: '08.09.2022',
                    size: 'PDF 0.25 МБайт',
                },
            ],*/
        }
    },
}
</script>

<style lang="scss">
.expansion-docs {
  .v-expansion-panel {
    box-shadow: none;
    border-radius: 24px !important;
    border: 1px solid rgba(232, 232, 232, 1);

    &:hover {
      border-color: rgba(79, 77, 85, 1);
    }
  }

  .v-expansion-panel:not(:first-child)::after{
    display: none;
  }

  .v-expansion-panel.v-expansion-panel--active.v-item--active {
    border: 1px solid rgba(79, 77, 85, 1) !important;
  }

  .v-expansion-panel::before {
    box-shadow: none;
  }

  .v-expansion-panel-header {
    padding: 36px 32px;
    display: flex;
    width: 100%;
  }

  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 96px;
    padding-bottom: 28px;

  }

  .v-expansion-panel--active > .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
    transform: rotate(-135deg);
  }

  .mdi:before, .mdi-set {
    color: #252525;
    font-size: 36px;
  }

}

</style>

<style lang="scss" scoped>
.expansion-docs {
  margin-top: 80px;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-style: 500;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: rgba(33, 36, 36, 1);
    margin: 0;
  }

  &__list {
    padding-left: 0;
    list-style-type: none;
  }

  &__item {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__link {
    position: relative;
    padding: 26px 24px;
    background: rgba(245, 245, 247, 1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    transition: all 0.2s ease;

    &:hover {
      & svg {
        color: rgba(33, 36, 36, 1);
      }

      & .expansion-docs__info > span {
        text-decoration: underline;
      }
    }

    @media (max-width: 500px) {
      flex-wrap: wrap;
      gap: 0;

      & img {
        display: block;
        margin-bottom: 20px;
      }
    }

    & svg {
      color: rgba(170, 170, 170, 1);
      transition: all 0.2s ease;

      @media (max-width: 500px) {
        position: absolute;
        top: 36px;
        right: 32px;
      }
    }

  }

  &__info {
    width: 100%;

    &--details {

      & > span {
        position: relative;
        font-family: 'RobotoRegular';
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0px;
        color: rgba(100, 100, 100, 1) !important;

        &:first-of-type {
          padding-right: 28px;

          &:after {
            position: absolute;
            content: '';
            right: 11px;
            top: 2px;
            height: 75%;
            width: 1px;
            background: rgba(100, 100, 100, 1);
          }
        }
      }
    }

    & > span {
      font-family: 'MuseoSansCyrl-500';
      font-weight: 400;
      font-style: 500;
      font-size: 18px;
      leading-trim: NONE;
      line-height: 24px;
      letter-spacing: 0px;
      color: rgba(40, 40, 40, 1) !important;
      text-decoration: underline transparent;
      transition: all 0.2s ease;
    }
  }
}
</style>